import words from 'lodash/words'

export const getNameInitials = name => {
  if (!name) return ''

  const names = words(name.toUpperCase())
  if (names.length === 0) return ''

  const firstname = names[0][0]
  if (names.length === 1) return firstname

  const surname = names[names.length - 1][0]
  return `${firstname}${surname}`
}
